import { render, staticRenderFns } from "./RecedeList.vue?vue&type=template&id=5dc63a28&"
import script from "./RecedeList.vue?vue&type=script&lang=js&"
export * from "./RecedeList.vue?vue&type=script&lang=js&"
import style0 from "./RecedeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports